module.exports = __webpack_public_path__ + "img/9788954436281.a032a77b.jpg";